export default "__VITE_ASSET__b5e11b2f__"